import CustomizeHomepageServiceV2 from '../../../services/v2/CustomizeHomepageServiceV2';
import customizeHomepageUseCaseV2 from './customizeHomepageUseCaseV2';

const customizeHomepageFactoryV2 = customizeHomepageUseCaseV2({
  CustomizeHomepageServiceV2: CustomizeHomepageServiceV2(),
});

export default customizeHomepageFactoryV2;
